import forms from "@tailwindcss/forms"

export default {
  content: [
    "./index.html",
    "./src/**/*.{vue,js,cjs,mjs,mdx}",
    "./node_modules/@repowerednl/ui-component-library/src/**/*.{vue,js,cjs,mjs,mdx}",
  ],
  theme: {
    colors: {
      transparent: "transparent",
      current: "currentColor",
      black: "#000",
      white: "#fff",
      primary: {
        50: "#E1EFE3",
        100: "#C8E6CE",
        200: "#AEDDB9",
        300: "#7ACA8E",
        400: "#47B863",
        500: "#13A538",
        DEFAULT: "#13A538",
        600: "#188D3C",
        700: "#1C753F",
        800: "#205D43",
        900: "#244546",
      },
      gray: {
        50: "#F3F5F6",
        75: "#E9EDEF",
        100: "#DEE4E8",
        200: "#C8D3D9",
        300: "#849197",
        400: "#627076",
        500: "#3F4E55",
        DEFAULT: "#3F4E55",
        600: "#39474D",
        700: "#344146",
        800: "#2F3B40",
        900: "#2B363A",
      },
      lightgray: {
        200: "#F3F5F6",
        300: "#E9EDEF",
        400: "#DEE4E8",
        500: "#C8D3D9",
        DEFAULT: "#C8D3D9",
        600: "#849197",
        700: "#627076",
        800: "#3F4E55",
        900: "#39474D",
      },
      energy: {
        50: "#FFF4CC",
        100: "#FFEFB3",
        200: "#FFE999",
        300: "#FFDE66",
        400: "#FFD333",
        500: "#FFC700",
        DEFAULT: "#FFC700",
        600: "#E8B500",
        700: "#D3A500",
        800: "#C09600",
        900: "#AF8800",
      },
      finance: {
        50: "#EAF6FE",
        100: "#CDEAF9",
        200: "#B0DEF3",
        300: "#75C5E8",
        400: "#3BACDD",
        500: "#0093D2",
        DEFAULT: "#0093D2",
        600: "#0086BF",
        700: "#007AAE",
        800: "#006F9E",
        900: "#006590",
      },
      success: {
        50: "#E1EFE3",
        100: "#C8E6CE",
        200: "#AEDDB9",
        300: "#7ACA8E",
        400: "#47B863",
        500: "#13A538",
        DEFAULT: "#13A538",
        600: "#188D3C",
        700: "#1C753F",
        800: "#205D43",
        900: "#244546",
      },
      danger: {
        50: "#FBD2D2",
        100: "#F9C6C6",
        200: "#F7BABA",
        300: "#F2A2A2",
        400: "#E97171",
        500: "#D61010",
        DEFAULT: "#D61010",
        600: "#C30F0F",
        700: "#B10E0E",
        800: "#A10D0D",
        900: "#920C0C",
      },
      info: {
        50: "#FFF4CC",
        100: "#FFEFB3",
        200: "#FFE999",
        300: "#FFDE66",
        400: "#FFD333",
        500: "#FFC700",
        DEFAULT: "#FFC700",
        600: "#E8B500",
        700: "#D3A500",
        800: "#C09600",
        900: "#AF8800",
      },
      orange: {
        50: "#FFF0E1",
        100: "#FFD0A9",
        200: "#FFAF71",
        300: "#FF8F39",
        400: "#FF7F1D",
        500: "#FF6E00",
        DEFAULT: "#FF6E00",
        600: "#E86400",
        700: "#D35B00",
        800: "#C05300",
        900: "#AF4B00",
      },
    },
    boxShadow: {
      sm: "0  1px  2px   0   rgba(0, 0, 0, 0.08)",
      DEFAULT:
        "0  1px  2px  -1px rgba(0, 0, 0, 0.10), 0  1px  3px  0   rgba(0, 0, 0, 0.10)",
      md: "0  2px  4px  -2px rgba(0, 0, 0, 0.05), 0  4px  6px -1px rgba(0, 0, 0, 0.10)",
      lg: "0  4px  6px   0   rgba(0, 0, 0, 0.05), 0 10px 15px -3px rgba(0, 0, 0, 0.10)",
      xl: "0 10px 10px   0   rgba(0, 0, 0, 0.04), 0 20px 25px -5px rgba(0, 0, 0, 0.10)",
      "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    },
    extend: {
      fontFamily: {
        sans: ["Aeonik", "Avenir", "ui-sans-serif"],
      },
    },
  },
  plugins: [forms],
}
